var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading-wrapper"}},[_c('div',{attrs:{"id":"loading-text"}},[_vm._v("LOADING")]),_c('div',{attrs:{"id":"loading-content"}})])
}]

export { render, staticRenderFns }